import request from '@/utils/request'


// 重构接口start
// 应用管理接口优化(应用秘钥重置,修改应用名称,应用详情接口)
export const appCollectione = date => {
  return request({
    url: '/app/collectione',
    method: 'post',
    data: date
  })
}
// 账号管理接口优化(验证密码，我的等级 ，基本个人信息，修改账户手机号，修改个人信息)
export const accountCollectione = date => {
  return request({
    url: '/account/collectione',
    method: 'post',
    data: date
  })
}
// 分组管理接口优化(分组成员列表，分组添加，分组删除，分组修改，权限保存，返回权限列表，获取分组权限接口)
export const groupCollectione = date => {
  return request({
    url: '/subaccount/group/collectione',
    method: 'post',
    data: date
  })
}
  // 客户管理接口优化 (我的邀请码,我的关联客户,我的客户,获取客户数量)
  export const collectione = data => {
    return request({
      url: '/agent/collectione',
      method: 'get',
      params: data
    })
  }
// 重构接口end

// 获取邀请链接
export const getBaseSettingDomain = () => {
  return request({
    url: '/oem/getBaseSettingDomain',
    method: 'get'
  })
}
// 获取目录
export const TypeListALL = date => {
  return request({
    url: 'http://192.168.26.179:6601/api/v1/document/externalTypeListALL',
    // url: 'http://sysapi.jxhh.com/api/v1/document/externalTypeListALL',
    method: 'get',
    params: date
  })
}
// 获取页面
export const externalShow = date => {
  return request({
    // url: 'http://sysapi.jxhh.com/api/v1/document/externalShow',
    url: 'http://192.168.26.179:6601/api/v1/document/externalShow',
    method: 'get',
    params: date
  })
}
// 测试工具提交
export const TestApi = date => {
  return request({
    url: 'http://192.168.26.179:6601/api/v1/document/testApi',
    // url: 'http://sysapi.jxhh.com/api/v1/document/testApi',
    method: 'post',
    data: date
  })
}
// 文档列表
export const ExternalList = date => {
  return request({
    url: 'http://192.168.26.179:6601/api/v1/document/externalList',
    // url: 'http://sysapi.jxhh.com/api/v1/document/externalList',
    method: 'get',
    params: date
  })
}
// 一级目录
export const ExternalTypeList = date => {
  return request({
    url: 'http://192.168.26.179:6601/api/v1/document/externalTypeList',
    // url: 'http://sysapi.jxhh.com/api/v1/document/externalTypeList',
    method: 'get',
    params: date
  })
}

// 首页接口
export const getinfo = date => {
  return request({
    url: '/index/info',
    method: 'post',
    data: date
  })
}

// 应用部分
// 获取应用基本信息
export const getaccountchange = () => {
  return request({
    url: '/account/me',
    method: 'get'
  })
}
// 获取应用列表
export const application = data => {
  return request({
    url: '/myapps',
    method: 'get',
    params: data
  })
}
// 应用基本信息修改更新
export const changeapplication = date => {
  return request({
    url: '/app/update',
    data: date,
    method: 'post'
  })
}
// 应用提交审核
export const applaylations = date => {
  return request({
    url: '/app/auth',
    data: date,
    method: 'post'
  })
}
// 应用提交上线
export const applayonline = date => {
  return request({
    url: '/app/online',
    data: date,
    method: 'post'
  })
}
// 提交白名单
export const postwhitelist = date => {
  return request({
    url: '/app/whitelist',
    data: date,
    method: 'post'
  })
}

// 账号star
// 子账号分组开始
// 创建分组
export const creatsubgroup = date => {
  return request({
    url: '/subaccount/group/create',
    data: date,
    method: 'post'
  })
}
// 获取所有权限
export const getauther = () => {
  return request({
    url: '/subaccount/group/methods',
    method: 'get'
  })
}
// 获取分组权限
export const getgroupouther = data => {
  return request({
    url: '/subaccount/group/role/',
    method: 'get',
    params: data
  })
}

// 设置分组权限
export const greatgroup = date => {
  return request({
    url: '/subaccount/group/role/save',
    data: date,
    method: 'post'
  })
}
// 删除分组
export const delgroups = date => {
  return request({
    // url: '/v1/agent',
    url: '/subaccount/group/del',
    data: date,
    method: 'post'
  })
}
// 修改分组名称
export const creatnewname = date => {
  return request({
    url: '/subaccount/group/update',
    data: date,
    method: 'post'
  })
}
// 修改密码
export const xgPassword = date => {
  return request({
    url: '/account/changepwd',
    data: date,
    method: 'post'
  })
}

// 修改账号
export const changephone = date => {
  return request({
    url: '/account/change/phone',
    data: date,
    method: 'post'
  })
}

// 修改账号获取验证码
export const getyzms = date => {
  return request({
    url: '/getcode',
    data: date,
    method: 'post'
  })
}
// 修改账号验证密码,短信
export const yzPassword = date => {
  return request({
    url: '/account/verifypwd',
    data: date,
    method: 'post'
  })
}
// 创建子账号
export const creatchild = date => {
  return request({
    // url: '/v1/agent',
    url: '/subaccount/create',
    data: date,
    method: 'post'
  })
}
// 子账号列表
export const getchildlist = data => {
  return request({
    url: '/subaccount/lists/',
    method: 'get',
    params: data
  })
}
// 子账号修改
export const updatechild = date => {
  return request({
    url: '/subaccount/update',
    data: date,
    method: 'post'
  })
}
// 子账号删除
export const delsschild = date => {
  return request({
    url: '/subaccount/del',
    data: date,
    method: 'post'
  })
}
// 更新基本信息
export const accountchange = date => {
  return request({
    url: '/account/updateInfo',
    data: date,
    method: 'post'
  })
}
// 初始化公司信息
export const getgroupInfo = () => {
  return request({
    url: '/account/auth/get',
    method: 'get'
  })
}
// 提交公司信息
export const getgroupauth = date => {
  return request({
    url: '/account/auth/add',
    data: date,
    method: 'post'
  })
}
// 获取省
export const getarea = data => {
  return request({
    url: '/area/',
    method: 'get',
    params: data
  })
}
// 上传图片
export const postphoto = date => {
  return request({
    url: '/upload',
    data: date,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
// 获取是否选择版本
export const getachooselevel = () => {
  return request({
    url: '/account/select/level',
    method: 'get'
  })
}
// 提交个人资质信息
export const getgroupperson = date => {
  return request({
    url: '/account/auth/person',
    data: date,
    method: 'post'
  })
}
// 账号end

// 推广部分
// 获取邀请码及链接
export const getshare = () => {
  return request({
    url: '/account/share',
    method: 'get'
  })
}
// 获取邀请人列表
export const shareList = date => {
  return request({
    url: '/account/sharelist?limit=' + date.limit + '&page=' + date.page,
    method: 'get'
  })
}

// 管理员创建
export const postagent = date => {
  return request({
    // url: '/v1/agent',
    url: '/agent/create',
    data: date,
    method: 'post'
  })
}
// 消息部分
// 消息列表
export const massageList = date => {
  return request({
    url: '/apimessage/list',
    // params: date,
    // method: 'get'
    method: 'post',
    data: date
  })
}
// 消息详情
export const massageInfo = date => {
  return request({
    url: '/apimessage/info',
    params: date,
    method: 'get'
  })
}
// 消息重发
export const massageRetry = date => {
  return request({
    url: '/apimessage/resend',
    data: date,
    method: 'post'
  })
}
// 消息发送测试页面获取回调地址
export const applicationidnew = () => {
  return request({
    url: '/apimessage/app/info',
    method: 'get'
  })
}
// 消息测试
export const massageTest = date => {
  return request({
    url: '/apimessage/testSend',
    data: date,
    method: 'post'
  })
}
// 上传应用图标
export const postappphoto = date => {
  return request({
    url: '/tools/appicon',
    data: date,
    method: 'post'
  })
}
// 获取应用基本信息概览
export const applicationid = data => {
  return request({
    url: '/app/info',
    method: 'get',
    params: data
  })
}

// //////
